export default __webpack_public_path__ + "static/media/SC40.cc538e87.jpg";